import { GridActionsColDef } from '@mui/x-data-grid';
import { ExtendedGridColDef } from 'types/datagrid';
import { supplierValueGetter } from 'ui-component/DataGrid/ValueGetters';

export const columns: (ExtendedGridColDef | GridActionsColDef)[] = [
  {
    field: 'name',
    headerName: 'Name',
    description: 'Name of the purchase rule',
    type: 'string',
    flex: 1,
    hideable: false,
  },
  {
    field: 'authorizedOnly',
    headerName: 'Authorized Only',
    description:
      'Indicates if the purchase rule is for authorized suppliers only',
    type: 'boolean',
    flex: 1,
    hideable: true,
  },
  {
    field: 'requiredCertifications',
    headerName: 'Required Certifications',
    description: 'Required certifications for the purchase rule',
    type: 'string',
    flex: 1,
    hideable: true,
  },
  {
    field: 'allowedSuppliers',
    headerName: 'Allowed Suppliers',
    description: 'Suppliers allowed under the purchase rule',
    type: 'string',
    flex: 1,
    hideable: true,
    valueGetter: supplierValueGetter,
  },
  {
    field: 'preferredSuppliers',
    headerName: 'Preferred Suppliers',
    description: 'Preferred suppliers under the purchase rule',
    type: 'string',
    flex: 1,
    hideable: true,
    valueGetter: supplierValueGetter,
  },
  {
    field: 'bannedSuppliers',
    headerName: 'Banned Suppliers',
    description: 'Suppliers banned under the purchase rule',
    type: 'string',
    flex: 1,
    hideable: true,
    valueGetter: supplierValueGetter,
  },
  {
    field: 'lastResortSuppliers',
    headerName: 'Last Resort Suppliers',
    description:
      'Suppliers to be used as a last resort under the purchase rule',
    type: 'string',
    flex: 1,
    hideable: true,
    valueGetter: supplierValueGetter,
  },

  {
    field: 'isDefaultPurchaseRule',
    headerName: 'Is Default Purchase Rule',
    description: 'Indicates if the purchase rule is the default',
    type: 'boolean',
    flex: 1,
    hideable: true,
  },
  {
    field: 'id',
    headerName: 'ID',
    description: 'Cofactr ID of this purchase rule',
    type: 'string',
    minWidth: 80,
    flex: 1,
  },
];
